/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMusic = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M22 2v14.054c0 2.186-1.794 3.964-4 3.964s-4-1.778-4-3.964 1.794-3.964 4-3.964c.728 0 1.412.194 2 .532V4.34L10 5.99v12.045C10 20.222 8.206 22 6 22s-4-1.778-4-3.964 1.794-3.964 4-3.964c.728 0 1.412.194 2 .532V4.314zM6 16.054c-1.103 0-2 .889-2 1.982s.897 1.982 2 1.982 2-.889 2-1.982a1.993 1.993 0 0 0-2-1.982zm12-1.982c-1.103 0-2 .889-2 1.982s.897 1.982 2 1.982 2-.89 2-1.982-.897-1.982-2-1.982z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgMusic as Music };
